import { __assign } from "tslib";
import { isLocalBusinessMeta, isRecipeMeta, isArticleMeta, isWebPageMeta, isProductMeta, } from './genericMeta';
export var getJsonLdPerson = function (name) {
    return name ? ({
        '@type': 'Person',
        name: name,
    }) : undefined;
};
export var getJsonLdPostalAddress = function (data) { return ({
    '@type': 'PostalAddress',
    streetAddress: data.streetAddress,
    addressLocality: data.locality,
    addressCountry: 'FI',
}); };
export var getJsonLdImage = function (imageUrl) {
    return imageUrl ? ({
        '@type': 'ImageObject',
        url: imageUrl,
    }) : undefined;
};
export var getJsonLdOrganization = function (organization) {
    return organization ? ({
        '@type': 'Organization',
        name: organization.name,
        url: organization.url || '',
        logo: getJsonLdImage(organization.logoUrl),
    }) : undefined;
};
export var getJsonLdHowToStep = function (text) { return ({
    '@type': 'HowToStep',
    text: text,
}); };
export var getJsonLdOpeningHours = function (hours) {
    return hours.map(function (data) { return (__assign({ '@type': 'OpeningHoursSpecification' }, data)); });
};
var mapJsonLdProductGtin = function (ean) { return function (product) {
    return ean.length === 13 ? __assign(__assign({}, product), { gtin13: ean }) : // EAN-13
        ean.length === 8 ? __assign(__assign({}, product), { gtin8: ean }) : // EAN-8
            ean.length === 12 ? __assign(__assign({}, product), { gtin12: ean }) : // GTIN-12
                ean.length === 14 ? __assign(__assign({}, product), { gtin14: ean }) : // GTIN-14
                    product;
}; };
export var getJsonLdBrand = function (brand) {
    return ({
        '@type': 'Brand',
        name: brand.name,
    });
};
export var getJsonLdProduct = function (_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description, brand = _a.brand, ean = _a.ean, _b = _a.category, category = _b === void 0 ? '' : _b;
    return mapJsonLdProductGtin(ean)({
        '@type': 'Product',
        name: name,
        description: description || '',
        image: image || '',
        brand: getJsonLdBrand(brand),
        productID: "ean:" + ean,
        url: url || '',
        category: category,
    });
};
export var getJsonLdWebPage = function (_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description, publisher = _a.publisher;
    return ({
        '@type': 'WebPage',
        name: name,
        image: image || '',
        url: url || '',
        description: description || '',
        publisher: getJsonLdOrganization(publisher),
    });
};
export var getJsonLdArticle = function (_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description, publisher = _a.publisher, authorName = _a.authorName, datePublished = _a.datePublished;
    return ({
        '@type': 'Article',
        name: name,
        image: image || '',
        url: url || '',
        description: description || '',
        author: getJsonLdPerson(authorName),
        publisher: getJsonLdOrganization(publisher),
        datePublished: datePublished,
    });
};
var getJsonLdPreparationTime = function (time) {
    return time !== undefined
        ? "PT" + time + "M"
        : undefined;
};
export var getJsonLdRecipe = function (_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description, publisher = _a.publisher, preparationTime = _a.preparationTime, ingredients = _a.ingredients, instructions = _a.instructions;
    return ({
        '@type': 'Recipe',
        name: name,
        image: image || '',
        description: description || '',
        url: url || '',
        totalTime: getJsonLdPreparationTime(preparationTime),
        recipeIngredient: ingredients.map(function (_a) {
            var ingredientName = _a.name, amount = _a.amount, unit = _a.unit;
            return amount + " " + unit + " " + ingredientName;
        }),
        recipeInstructions: instructions.map(getJsonLdHowToStep),
        publisher: getJsonLdOrganization(publisher),
    });
};
export var getJsonLdLocalBusiness = function (_a) {
    var name = _a.name, image = _a.image, description = _a.description, email = _a.email, telephone = _a.telephone, faxNumber = _a.faxNumber, address = _a.address, openingHoursSpecification = _a.openingHoursSpecification;
    return ({
        '@type': 'LocalBusiness',
        name: name,
        image: image || '',
        description: description || '',
        email: email,
        telephone: telephone,
        faxNumber: faxNumber,
        address: getJsonLdPostalAddress(address),
        openingHoursSpecification: getJsonLdOpeningHours(openingHoursSpecification),
    });
};
export var mapMetaToJsonLd = function (meta) {
    return isLocalBusinessMeta(meta) ? getJsonLdLocalBusiness(meta) :
        isRecipeMeta(meta) ? getJsonLdRecipe(meta) :
            isArticleMeta(meta) ? getJsonLdArticle(meta) :
                isWebPageMeta(meta) ? getJsonLdWebPage(meta) :
                    isProductMeta(meta) ? getJsonLdProduct(meta) :
                        undefined;
};
